/* ============================================================
   Cart Badge (赤丸バッジ) — 安定化 v1.2
   - 対象: a.header__icon--cart（ヘッダー／ドロワー共通）
   - 取得: /cart.js で item_count を取得、PubSub(cartUpdate / quantityUpdate)で随時更新
   - 再描画対策: 毎回“今あるDOM”を取り直して取り付け。lastCountを保持して再反映。
   - 4バリエーション: data-cb-variant="mobile|mobile-menu|desktop|desktop-menu"
   ============================================================ */
(function(){
  const VARIANTS = {
    MOBILE: 'mobile',
    MOBILE_MENU: 'mobile-menu',
    DESKTOP: 'desktop',
    DESKTOP_MENU: 'desktop-menu'
  };

  const SELECTOR = 'a.header__icon--cart';

  const BADGE_HTML =
    '<span class="cb-badge" hidden aria-live="polite" aria-atomic="true" role="status" data-cb-badge>' +
      '<span class="cb-badge__num" aria-hidden="true">0</span>' +
      '<svg class="cb-badge__svg" viewBox="0 0 14 14" width="14" height="14" aria-hidden="true" focusable="false">' +
        '<defs>' +
          '<mask class="cb-badge__mask" maskUnits="userSpaceOnUse" x="0" y="0" width="14" height="14">' +
            '<rect width="14" height="14" fill="white"></rect>' +
            '<text class="cb-badge__svg-num" x="7" y="7" text-anchor="middle" dominant-baseline="central" fill="black">0</text>' +
          '</mask>' +
        '</defs>' +
        '<circle class="cb-badge__svg-circle" cx="7" cy="7" r="6.4"></circle>' +
      '</svg>' +
     '<span class="visually-hidden">Cart items</span>' +
    '</span>';

  function $(sel, root=document){ return root.querySelector(sel); }
  function $all(sel, root=document){ return Array.from(root.querySelectorAll(sel)); }

  function ensureBadge(container){
    if (!container) return null;
    let badge = $('[data-cb-badge]', container);
    if (!badge){
      container.insertAdjacentHTML('beforeend', BADGE_HTML);
      badge = $('[data-cb-badge]', container);
    }
    // 既存バッジが先に存在している場合も、SVGマスク用の中身を後付けする
    if (badge && !$('.cb-badge__svg', badge)){
      badge.insertAdjacentHTML('beforeend',
        '<svg class="cb-badge__svg" viewBox="0 0 14 14" width="14" height="14" aria-hidden="true" focusable="false">' +
          '<defs>' +
            '<mask class="cb-badge__mask" maskUnits="userSpaceOnUse" x="0" y="0" width="14" height="14">' +
              '<rect width="14" height="14" fill="white"></rect>' +
              '<text class="cb-badge__svg-num" x="7" y="7" text-anchor="middle" dominant-baseline="central" fill="black">0</text>' +
            '</mask>' +
          '</defs>' +
          '<circle class="cb-badge__svg-circle" cx="7" cy="7" r="6.4"></circle>' +
        '</svg>'
      );
    }
    // レイアウトを崩さない最低限の付与（containは使わない）
    if (getComputedStyle(container).position === 'static'){
      container.style.position = 'relative';
    }
    return badge;
  }

  function capCount(n){ return (n > 99) ? '99+' : String(n); }
  function readCssVar(el, name, fallback){
    if (!el) return fallback;
    const value = getComputedStyle(el).getPropertyValue(name).trim();
    return value || fallback;
  }

  function numberFontSizeVar(value){
    if (value.length >= 3) return '--cb-svg-font-size-3';
    if (value.length === 2) return '--cb-svg-font-size-2';
    return '--cb-svg-font-size-1';
  }

  function applySvgNumberMetrics(badgeEl, svgNum, value){
    if (!badgeEl || !svgNum) return;
    const fallbackSize = value.length >= 3 ? '4.5px' : value.length === 2 ? '5.6px' : '6.8px';
    const size = readCssVar(badgeEl, numberFontSizeVar(value), fallbackSize).replace('px','');
    const x = readCssVar(badgeEl, '--cb-svg-x', '7px').replace('px','');
    const y = readCssVar(badgeEl, '--cb-svg-y', '7px').replace('px','');
    svgNum.setAttribute('font-size', size);
    svgNum.setAttribute('x', x);
    svgNum.setAttribute('y', y);
  }


  let svgMaskSerial = 0;
  function ensureSvgMask(badgeEl){
    if (!badgeEl) return;
    const svg = $('.cb-badge__svg', badgeEl);
    const mask = $('.cb-badge__mask', badgeEl);
    const circle = $('.cb-badge__svg-circle', badgeEl);
    if (!svg || !mask || !circle) return;
    if (!mask.id){
      svgMaskSerial += 1;
      mask.id = 'cb-badge-knockout-' + svgMaskSerial;
      circle.setAttribute('mask', 'url(#' + mask.id + ')');
    }
    badgeEl.classList.add('cb-badge--svgmask-ready');
  }

  function setBadgeCount(badgeEl, count){
    if (!badgeEl) return;
    ensureSvgMask(badgeEl);
    const value = capCount(count);
    const inner = $('.cb-badge__num', badgeEl);
    const svgNum = $('.cb-badge__svg-num', badgeEl);
    const svg = $('.cb-badge__svg', badgeEl);
    if (count > 0){
      if (inner) inner.textContent = value;
      if (svgNum) {
        svgNum.textContent = value;
        applySvgNumberMetrics(badgeEl, svgNum, value);
        svgNum.setAttribute('font-family', 'Hiragino Kaku Gothic Pro, YuGothic, Meiryo, Arial, sans-serif');
        svgNum.setAttribute('font-weight', '700');
        svgNum.setAttribute('letter-spacing', value.length >= 2 ? '-0.35' : '0');
      }
      if (svg) svg.setAttribute('data-count', value);
      badgeEl.hidden = false;
    } else {
      badgeEl.hidden = true;
    }
  }

  function detectVariant(anchor){
    const isMenu = !!anchor.closest('header-drawer, .menu-drawer, #Details-menu-drawer-container');
    const isDesktop = window.matchMedia('(min-width: 750px)').matches;
    return isDesktop ? (isMenu ? VARIANTS.DESKTOP_MENU : VARIANTS.DESKTOP)
                     : (isMenu ? VARIANTS.MOBILE_MENU : VARIANTS.MOBILE);
  }

  function applyVariant(anchor){
    anchor.setAttribute('data-cb-variant', detectVariant(anchor));
    // CSS側のバリアント（header/drawer）用クラスも付与
    anchor.classList.add('cb-badge-host');
    var inDrawer = !!anchor.closest('header-drawer, .menu-drawer, #Details-menu-drawer-container, .drawer, .menu__drawer, [data-drawer]');
    anchor.classList.toggle('cb-badge-host--drawer', inDrawer);
    anchor.classList.toggle('cb-badge-host--header', !inDrawer);
  }

  function applyVariantAll(){ $all(SELECTOR).forEach(applyVariant); }

  async function fetchCartCount(){
    try{
      const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      if (!res.ok) throw new Error('cart.js failed');
      const data = await res.json();
      return (data && typeof data.item_count === 'number') ? data.item_count : 0;
    } catch(e){
      return 0;
    }
  }

  // ★ 常に「今あるDOM」を取り直して更新する（差し替え対策）
  const getBadges = () => $all(SELECTOR).map(ensureBadge);
  let lastCount = 0;

  function updateAllBadges(n){
    lastCount = n;
    // CSS変数（--cb-svg-y など）は .cb-badge-host--header / --drawer が付いてから読む
    // 先にバリアントclassを付けないと、SVG数字位置のCSS変数が fallback の 7px で固定される
    applyVariantAll();
    const badges = getBadges();
    applyVariantAll();
    badges.forEach(b => setBadgeCount(b, n));
  }

  async function init(){
    if (window.__cb_cart_badge_initialized) return;
    window.__cb_cart_badge_initialized = true;

    // 初期取り付け＆初期値反映
    updateAllBadges(await fetchCartCount());

    // PubSub にフック（最優先：payload、フォールバック：/cart.js）＋レース防止
    try{
      const sub = window.subscribe || (typeof subscribe === 'function' && subscribe);
      const evs = [];
      if (typeof PUB_SUB_EVENTS !== 'undefined') {
        if (PUB_SUB_EVENTS.cartUpdate)     evs.push(PUB_SUB_EVENTS.cartUpdate);
        if (PUB_SUB_EVENTS.quantityUpdate) evs.push(PUB_SUB_EVENTS.quantityUpdate);
      } else if (window.PUB_SUB_EVENTS) {
        if (window.PUB_SUB_EVENTS.cartUpdate)     evs.push(window.PUB_SUB_EVENTS.cartUpdate);
        if (window.PUB_SUB_EVENTS.quantityUpdate) evs.push(window.PUB_SUB_EVENTS.quantityUpdate);
      }

      let latestReq = 0;
      const updateFromServer = () => {
        const ticket = ++latestReq;
        return fetchCartCount().then(n => {
          if (ticket !== latestReq) return; // 遅延応答は捨てる
          updateAllBadges(n);
        });
      };

      if (sub && evs.length){
        evs.forEach(evName => {
          sub(evName, (payload) => {
            const n = payload && payload.cartData && typeof payload.cartData.item_count === 'number'
              ? payload.cartData.item_count
              : null;
            if (n !== null){
              // 正値が来ている時は即反映。以後の遅いfetchは無視
              latestReq++;
              updateAllBadges(n);
            } else {
              updateFromServer();
            }
          });
        });
      }
    } catch(err){ /* no-op */ }

// ✅ 置き換え（安全版）
try{
  const observer = new MutationObserver(() => {});
  observer.observe(document.documentElement, { childList: true, subtree: true });
}catch(e){
  console.warn('[cb-badge] observer disabled', e);
}

    // セクション再描画イベントでも再同期
    document.addEventListener('shopify:section:load',   () => updateAllBadges(lastCount), true);
    document.addEventListener('shopify:section:select', () => updateAllBadges(lastCount), true);
    document.addEventListener('shopify:section:reorder',() => updateAllBadges(lastCount), true);

    // ドロワーの <details> 開閉でも再同期（ヘッダーDOMに触れない操作でも確実化）
    document.addEventListener('toggle', (e) => {
    const t = e.target;
    if (!t) return;
    // メニュー・かご系detailsが開閉されたら、最新DOMにバッジを再装着＆直近カウント再反映
    if (t.matches('#Details-menu-drawer-container, header-drawer, .menu-drawer')) {
    updateAllBadges(lastCount);
    }
    }, true);

    // 画面幅やメニュー開閉で追従
    window.addEventListener('resize', applyVariantAll, { passive: true });
    document.addEventListener('toggle', applyVariantAll, true);
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ===== HOTFIX v1.4: 安全ガード＆ドロワー後に再装着 ===== */
(function(){
  // ドロワー開閉後に host フラグを必ず付け直し
  document.addEventListener('click', function(e){
    if (e.target.closest('[data-drawer], .menu-toggle, .js-menu-toggle, .header__icon--menu')) {
      setTimeout(function(){
        document.querySelectorAll('.cb-badge').forEach(function(badge){
          var host = badge && badge.parentElement;
          if(!host) return;
          host.classList.add('cb-badge-host');
          var inDrawer = !!badge.closest('.menu-drawer, .drawer, .menu__drawer, [data-drawer], .js-menu-drawer');
          host.classList.toggle('cb-badge-host--drawer', inDrawer);
          host.classList.toggle('cb-badge-host--header', !inDrawer);
        });
      }, 300);
    }
  });

  // MutationObserver まわりの TypeError を握りつぶす
  try{
    var mo = new MutationObserver(function(muts){
      for (var i=0;i<muts.length;i++){
        if (muts[i].addedNodes && muts[i].addedNodes.length){
          document.querySelectorAll('.cb-badge').forEach(function(b){
            var p = b && b.parentElement;
            if (p) p.classList.add('cb-badge-host');
          });
          break;
        }
      }
    });
    mo.observe(document.documentElement, {childList:true, subtree:true});
  }catch(_e){}
})();

// === host フラグを正しく付与（header 優先） ===
function tagHost(badge){
  if(!badge) return null;
  var host = badge.closest('.cb-badge-host') || badge.parentElement || badge;
  host.classList.add('cb-badge-host');

  // 「本物のドロワー領域」を限定（inner を含む）
  var inRealDrawer = !!badge.closest(
    '.menu-drawer__inner, .menu-drawer[open], .menu-drawer, ' +
    '.drawer--active, .drawer.is-open, .menu__drawer, [data-drawer], .js-menu-drawer'
  );
  var inHeader = !!badge.closest('header');

  // 一度クリアしてから確定付与
  host.classList.remove('cb-badge-host--header', 'cb-badge-host--drawer');
  if (inHeader && !inRealDrawer){
    host.classList.add('cb-badge-host--header');
  } else if (inRealDrawer){
    host.classList.add('cb-badge-host--drawer');
  } else {
    // どちらでもない場合は header 扱い（安全側）
    host.classList.add('cb-badge-host--header');
  }
  return host;
}

// 既存の ensureBadgeOn などから呼ばれるように差し替え
function ensureBadgeOn(el){
  var host = tagHost(el);
  if(!host) return null;
  var b = host.querySelector('.cb-badge');
  if(!b){
    b = document.createElement('span');
    b.className = 'cb-badge';
    b.setAttribute('aria-hidden','true');
    b.innerHTML = '<span class="cb-badge__num"></span>';
    host.appendChild(b);
  }
  return b;
}

// ドロワー開閉・DOM差し替え時にも再判定
document.addEventListener('click', function(e){
  if (e.target.closest('[data-drawer], .menu-toggle, .js-menu-toggle, .header__icon--menu')) {
    setTimeout(function(){
      document.querySelectorAll('.cb-badge').forEach(tagHost);
    }, 300);
  }
});
try{
  new MutationObserver(function(muts){
    for (var i=0;i<muts.length;i++){
      if (muts[i].addedNodes && muts[i].addedNodes.length){
        document.querySelectorAll('.cb-badge').forEach(tagHost);
        break;
      }
    }
  }).observe(document.documentElement, {childList:true, subtree:true});
}catch(_e){}

/* --- clear inline custom props (CSS運用用) --- */
document.addEventListener('DOMContentLoaded', function(){
  document.querySelectorAll('.cb-badge').forEach(function(b){
    ['--cb-size','--cb-font-size','--cb-tx','--cb-ty','--cb-nx','--cb-ny']
      .forEach(k => b.style.removeProperty(k));
  });
});
